import React, { useState } from "react";

// import "./styles.css";

import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { isEmpty } from "lodash";
import { Empty, Popconfirm, Spin , Collapse , Tooltip , Button , theme } from "antd";
import { MdOutlineArchive } from "react-icons/md";
import DragAndDropCollapse from "../DraggableCollapse";
import { RiDraggable } from "react-icons/ri";
import { sortLessonByOrder } from "../../utils";
import clock from "../../assets/Clock.png";
import { GoPlus } from "react-icons/go";
import { FiEdit2 } from "react-icons/fi";

const { Panel } = Collapse;

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

const getItemStyle = (isDragging, draggableStyle) => ({
  userSelect: "none",
  ...draggableStyle,
});

const getListStyle = (isDraggingOver) => ({
  width: "100%",
  position: "relative",
});

const LevelDragAndDrop = ({
  items,
  setItems,
  loading,
  addArchiveModule,
  handleAddTarget,
  handleEditModule,
  updateLevelDnD,
  handleTargetClick,
  addArchiveLesson,
  getLessonLength,
  handleAddModule,
  handleEditLevel,
  updateLevelModule,
  levelArch
}) => {
  // console.log("🚀 ~ items:", items)
  const [dragItemId, setDragItemId] = useState("");

  const queryAttr = "data-rbd-drag-handle-draggable-id";
  const [placeholderProps, setPlaceholderProps] = useState({});
  const { token } = theme.useToken();
  const handleDragStart = (event) => {
    const draggedDOM = getDraggedDom(String(event.draggableId));
    setDragItemId(event?.draggableId);

    if (!draggedDOM) {
      return;
    }

    const { clientHeight, clientWidth } = draggedDOM;
    const sourceIndex = event.source.index;
    const clientY =
      parseFloat(window.getComputedStyle(draggedDOM.parentNode).paddingTop) +
      [...draggedDOM.parentNode.children]
        .slice(0, sourceIndex)
        .reduce((total, curr) => {
          const style = curr.currentStyle || window.getComputedStyle(curr);
          const marginBottom = parseFloat(style.marginBottom);
          return total + curr.clientHeight + marginBottom;
        }, 0);

    setPlaceholderProps({
      clientHeight,
      clientWidth,
      clientY,
      clientX: parseFloat(
        window.getComputedStyle(draggedDOM.parentNode).paddingLeft
      ),
    });
  };

  const handleDragEnd = (result) => {
    setPlaceholderProps({});
    if (!result.destination) {
      return;
    }

    const listItems = reorder(
      items,
      result.source.index,
      result.destination.index
    );

    // console.log("Yolooooo", {
    //   items,
    //   source: result.source.index,
    //   destination: result.destination.index,
    // });

    const sourceId = items[result.source.index].levelId;
    const destinationId = items[result.destination.index].levelId;

    // console.log("Yolooooo", {
    //   sourceId,
    //   destinationId,
    // });
    // console.log("🚀 ~ handleDragEnd ~ listItems:", listItems)

    setItems(listItems);

    // handleDropEnd(listItems);

    setDragItemId("");
  };

  const handleDragUpdate = (event) => {
    if (!event.destination) {
      return;
    }

    const draggedDOM = getDraggedDom(String(event.draggableId));

    if (!draggedDOM) {
      return;
    }

    const { clientHeight, clientWidth } = draggedDOM;
    const destinationIndex = event.destination.index;
    const sourceIndex = event.source.index;

    const childrenArray = [...draggedDOM.parentNode.children];
    const movedItem = childrenArray[sourceIndex];
    childrenArray.splice(sourceIndex, 1);

    const updatedArray = [
      ...childrenArray.slice(0, destinationIndex),
      movedItem,
      ...childrenArray.slice(destinationIndex + 1),
    ];

    const clientY =
      parseFloat(window.getComputedStyle(draggedDOM.parentNode).paddingTop) +
      updatedArray.slice(0, destinationIndex).reduce((total, curr) => {
        const style = curr.currentStyle || window.getComputedStyle(curr);
        const marginBottom = parseFloat(style.marginBottom);
        return total + curr.clientHeight + marginBottom;
      }, 0);

    setPlaceholderProps({
      clientHeight,
      clientWidth,
      clientY,
      clientX: parseFloat(
        window.getComputedStyle(draggedDOM.parentNode).paddingLeft
      ),
    });
  };

  const getDraggedDom = (draggableId) => {
    const domQuery = `[${queryAttr}='${draggableId}']`;
    const draggedDOM = document.querySelector(domQuery);

    return draggedDOM;
  };

  const getTargetLessonLength = (level) => {
    let length = level?.modules?.length ? level?.modules
      ?.map((module) => {
        return module?.targets
          .map((t) => t?.duration)
          .reduce((sum, val) => Number(sum) + Number(val), 0);
      })
      .reduce((sum, val) => Number(sum) + Number(val), 0) : 0;

    return length;
  };

  // Normally you would want to split things out into separate components.
  // But in this example everything is just done in one place for simplicity
  return (
    <DragDropContext
      onDragEnd={handleDragEnd}
      onDragStart={handleDragStart}
      onDragUpdate={handleDragUpdate}
    >
      <Droppable droppableId="droppable">
        {(provided, snapshot) => (
          <div
            {...provided.droppableProps}
            ref={provided.innerRef}
            style={getListStyle(snapshot.isDraggingOver)}
          >
            {loading ? (
              <div className="loadingBox">
                <Spin />
              </div>
            ) : items?.length > 0 ? (
              items.map((item, index) => (
                <Draggable
                  key={String(item.levelId)}
                  draggableId={String(item.levelId)}
                  index={index}
                >
                  {(provided, snapshot) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      style={getItemStyle(
                        snapshot.isDragging,
                        provided.draggableProps.style
                      )}
                      className={`${
                        dragItemId == item.levelId ? "activeDrag" : ""
                      } curriculumDetailLevel`}
                    >
                      <Collapse
                        bordered={false}
                        defaultActiveKey={["1"]}
                        expandIcon={() => false}
                        // expandIcon={({ isActive }) => (
                        //   <IoIosArrowDown
                        //     size={20}
                        //     className={`arrow-icon ${isActive ? "rotate" : ""} ${
                        //       hoveredPanel ? "hovered" : ""
                        //     }`}
                        //   />
                        // )}
                        style={{
                          background: token.colorBgContainer,
                        }}
                        accordion
                        className="_levelCollapse"
                      >
                        <Panel
                          header={
                            <p className="panel_hdr_content">
                              <Tooltip placement="bottom" title={"Hold and move to drag"}>
                                <div
                                  onClick={(e) => {
                                    e.stopPropagation();
                                  }}
                                  style={{display:"flex", alignItems:'center',height:'100%',cursor:'grab'}}
                                  >
                                    <RiDraggable size={20} />
                                  </div>
                              </Tooltip>
                              {item?.level}{" "}
                              {item?.modules?.length > 0 && (
                                <div className="moduledurationclock">
                                  <img
                                    src={clock}
                                    alt=""
                                    className="imgclock"
                                  />
                                  <p>
                                    Duration:{" "}
                                    {getLessonLength(item) === 1
                                      ? `${getLessonLength(item)} Target`
                                      : `${getLessonLength(item)} Targets`}
                                    {/* {calculateAllLessonsDuration(level)} */}
                                  </p>
                                </div>
                              )}
                              {item?.modules?.length > 0 && (
                                <div className="moduledurationclock">
                                  <img
                                    src={clock}
                                    alt=""
                                    className="imgclock"
                                  />
                                  <p>
                                    {getTargetLessonLength(item) === 1
                                      ? `${getTargetLessonLength(item)} Lesson`
                                      : `${getTargetLessonLength(item)} Lessons`}
                                    {/* {calculateAllLessonsDuration(level)} */}
                                  </p>
                                </div>
                              )}
                            </p>
                          }
                          key={index + 1}
                          className="collapsepanel"
                          extra={
                            <>
                              <Tooltip placement="bottom" title={"Add Module"}>
                                <Button
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleAddModule(item.levelId);
                                  }}
                                  className="black-button collapse_action_btn"
                                  icon={<GoPlus size={25} />}
                                />
                              </Tooltip>
                              <Tooltip placement="bottom" title={"Edit Level"}>
                                <Button
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleEditLevel(item);
                                  }}
                                  className="black-button collapse_action_btn"
                                  icon={<FiEdit2 size={22} />}
                                />
                              </Tooltip>
                              <Tooltip>
                                <Popconfirm
                                  title="Archive Level"
                                  description="Are you sure add to archive ?"
                                  onConfirm={(e) => {
                                    e?.stopPropagation();
                                    levelArch(item.levelId);
                                  }}
                                  okText="Yes"
                                  cancelText="No"
                                >
                                  <MdOutlineArchive
                                    className="archive_unarchive_btn"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                    }}
                                  />
                                </Popconfirm>
                              </Tooltip>
                            </>
                          }
                        >
                          <DragAndDropCollapse
                            items={sortLessonByOrder(item?.modules)}
                            level={item}
                            setItems={(modules) =>
                              updateLevelModule(item.levelId, modules)
                            }
                            loading={false}
                            addArchiveModule={addArchiveModule}
                            handleAddTarget={handleAddTarget}
                            handleEditModule={handleEditModule}
                            updateLevelDnD={updateLevelDnD}
                            handleTargetClick={handleTargetClick}
                            addArchiveLesson={addArchiveLesson}
                          />
                        </Panel>
                      </Collapse>
                    </div>
                  )}
                </Draggable>
              ))
            ) : (
              <Empty
                style={{ marginBottom: "30px" }}
                description="No step here"
              />
            )}
            {provided.placeholder}
            {!isEmpty(placeholderProps) && snapshot.isDraggingOver && (
              <div
                className="placeholder"
                style={{
                  top: placeholderProps?.clientY,
                  //   left: placeholderProps.clientX,
                  right: 0,
                  height: placeholderProps.clientHeight - 30,
                  width: placeholderProps.clientWidth - 40,
                }}
              />
            )}
          </div>
        )}
      </Droppable>

      {/* {type === "funnel" && <Footer />} */}
    </DragDropContext>
  );
};

export default LevelDragAndDrop;
